import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate, Link  } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Modal, Button, Form, Row, Col  } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreatePostContent = () => {
  const editor = useRef(null);
  const navigate = useNavigate();
  const [postcontentid, setPostContentId] = useState("");
  const [postcontentname, setPostContentName] = useState("");
  const [postcontenttitle, setPostContentTitle] = useState("");
  const [postcontent, setPostContent] = useState("");
  const [postcontenttype, setPostContentType] = useState("");
  const [postid, setPostId] = useState("");
  const [postlocationid, setPostLocationId] = useState("");
  const [isExistingPost, setIsExistingPost] = useState(false);


  const url = process.env.REACT_APP_API_URL;

  const [showCreateModal, setShowCreateModal] = useState(false)

  const handleFetchData = async () => {
    if (!postcontentid) {
      toast.warning("Please enter a Post Content Id first",{
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      return;
    }
    try {
      const headers = { 'x-access-token': localStorage.getItem('jwttoken') };
      const response = await axios.get(`${url}postcontent/${postcontentid}`, { headers });

      if (response.status === 200 && response.data.length > 0) {
        const data = response.data[0];
        setPostContentName(data.postcontentname || "");
        setPostContentTitle(data.postcontenttitle || "");
        setPostContent(data.postcontent || "");
        setPostContentType(data.postcontenttype || "");
        setPostId(data.postid || "");
        setPostLocationId(data.postlocationid || "");
        
        setIsExistingPost(true); 
        toast.success("Post content fetched successfully.",{
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      }
    } catch (err) {
      setIsExistingPost(false);
      if (err.response && err.response.status === 400) {
        toast.success("Post content not exist.You can create a new post.", {
            position: "top-right",
            autoClose: 2000,
            theme: "colored",
        });
      } else {
        toast.error("An error occurred while checking the ID.",{
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      }
    }
  };

  const handleCreate = async () => {
    setShowCreateModal(false)
    if (isExistingPost) {
      toast.error("Post content already exist.", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      return;
    }
    const postData = {
      postcontentid,
      postcontentname,
      postcontenttitle,
      postcontent,
      postcontenttype,
      postid,
      postlocationid,
      isactive: 1,
    };

    if (
      !postcontentid ||
      !postcontentname ||
      !postcontenttitle ||
      !postcontent ||
      !postcontenttype ||
      !postid ||
      !postlocationid
    ) {
      toast.error("Missing required parameters.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }
      try {
        const headers = {
          'x-access-token': localStorage.getItem('jwttoken')
        };
        const response = await axios.post(
          url + "postcontent/addNewData",
          postData, {headers}
        );

        if (response.status === 201) {
          toast.success("Post content created successfully", {
            position: "top-right",
            autoClose: 1000,
            theme: "colored",
          });
          setTimeout(() => {
            navigate("/postlist");
          }, 2000);
        } 
      } catch (err) {
        toast.error("An error occurred while creating the post content.", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      }
  }
  const handleSubmit = async (e) => {
   e.preventDefault()
   if (isExistingPost) {
      toast.error("Post content already exist. You cannot add it again.",{
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    } else {
   setShowCreateModal(true)
  };
}

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Add New Post Content
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="postcontentid">
                  <Form.Label>Post Content Id:</Form.Label>
                  <div className="d-flex gap-2">
                    <Form.Control
                      type="text"
                      value={postcontentid}
                      onChange={(e) => {
                        setPostContentId(e.target.value);
                        setIsExistingPost(false); 
                      }}
                      maxLength={50}
                      placeholder="Enter unique ID"
                    />
                    <Button variant="primary" onClick={handleFetchData} size="sm">
                      Fetch
                    </Button>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="postcontentname">
                  <Form.Label>Post Content Name:</Form.Label>
                  <Form.Control
                    type="text"
                    value={postcontentname}
                    onChange={(e) => setPostContentName(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="postcontenttitle">
                  <Form.Label>Post Content Title:</Form.Label>
                  <Form.Control
                    type="text"
                    value={postcontenttitle}
                    onChange={(e) => setPostContentTitle(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="postcontenttype">
                  <Form.Label>Post Content Type:</Form.Label>
                  <Form.Control
                    type="text"
                    value={postcontenttype}
                    onChange={(e) => setPostContentType(e.target.value)}
                    maxLength={20}
                  />
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="postcontent">
                <Form.Label>Post Content:</Form.Label>
                <JoditEditor
                  ref={editor}
                  value={postcontent}
                  onChange={(newContent) => setPostContent(newContent)}
                />
              </Form.Group>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="postid">
                  <Form.Label>Post Id:</Form.Label>
                  <Form.Control
                    type="number"
                    value={postid}
                    onChange={(e) => setPostId(e.target.value)}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="postlocationid">
                  <Form.Label>Post Location Id:</Form.Label>
                  <Form.Control
                    type="number"
                    value={postlocationid}
                    onChange={(e) => setPostLocationId(e.target.value)}
                  />
                </Form.Group>
              </Row>

               <div className="form-actions">
                    <button type="submit" className="btn-gradient-primary">
                    Add Post Content
                    </button>
                    <Link to="/postlist" className="btn-back-link">
                     ← Back to List
                    </Link>
               </div>
            </Form>
          </div>
        </div>

        <ToastContainer />

        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Post Content Create</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Sure you want to Create post content?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
                    Cancel
                  </Button>
                  <Button type="button" onClick={handleCreate} variant="primary" style={{ marginLeft: '10px' }}>
                    Create
                  </Button>
                </Modal.Footer>
              </Modal>
      </div>
    </>
  );
};

export default CreatePostContent;